import { render, staticRenderFns } from "./add_dialog.vue?vue&type=template&id=4aaa7b40&scoped=true"
import script from "./add_dialog.vue?vue&type=script&lang=js"
export * from "./add_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_dialog.vue?vue&type=style&index=0&id=4aaa7b40&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa7b40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aaa7b40')) {
      api.createRecord('4aaa7b40', component.options)
    } else {
      api.reload('4aaa7b40', component.options)
    }
    module.hot.accept("./add_dialog.vue?vue&type=template&id=4aaa7b40&scoped=true", function () {
      api.rerender('4aaa7b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/activity/activity_task/form/components/add_dialog.vue"
export default component.exports